import styles from './ModalMediaContent.module.scss';

type Props = {
  /**
   * The content to render.
   */
  children: React.ReactNode;
  /**
   * The rendered close button provided by `Modal`.
   */
  closeButton?: React.ReactNode;
};

export const ModalMediaContent = (props: Props) => {
  return (
    <div className={styles.root} data-zds>
      {props.children}
      {props.closeButton && (
        <div className={styles.closeButton} data-zds>
          {props.closeButton}
        </div>
      )}
    </div>
  );
};
